import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import { useMenu } from '../useMenu';
import SideMenuGroup from './SideMenuGroup';
import SideMenuItem from './SideMenuItem';
import { SideMenuSpacer } from './SideMenuSpacer';
import { Sidebar } from './Sidebar';
import { MenuProps } from '../menuTypes';
import { MenuContextProvider } from '../menuContext';
import { useAuth } from '@montel/montelpro-auth';
import { SideMenuSeparator } from './SideMenuSeparator';

const SideMenu: FunctionComponent<MenuProps> = ({
	menuConfig = [],
	w = '40px',
	bg = 'bgMainContainer',
	className,
	...otherProps
}) => {
	const { items, isActiveItemByIndex } = useMenu({
		items: menuConfig,
		locationProvider: useLocation,
	});

	const { user } = useAuth();

	return (
		<Sidebar $w={w} $bg={bg} className={className} {...otherProps}>
			<SideMenuGroup>
				{items.map((item, index) => {
					if (item.type === 'Clickable') {
						const { text, link, icon, allowedRoles } = item;
						if (
							allowedRoles &&
							user &&
							!user.roles?.some((role: string) =>
								allowedRoles.includes(role),
							)
						) {
							return;
						}

						return (
							<MenuContextProvider
								key={link}
								value={{
									index,
									isActive: isActiveItemByIndex(index),
								}}
							>
								<SideMenuItem
									text={text}
									link={link}
									icon={icon}
									h={w}
									tabIndex={-1}
								/>
							</MenuContextProvider>
						);
					}
					if (item.type === 'Separator') {
						return (
							<SideMenuSeparator
								as="li"
								key={`separator-${menuConfig[index - 1]}`}
							/>
						);
					}
					return (
						<SideMenuSpacer
							as="li"
							key={`spacer-${menuConfig[index - 1]}`}
						/>
					);
				})}
			</SideMenuGroup>
		</Sidebar>
	);
};

export default SideMenu;
